import { useEffect, useRef, useState } from "react";

import type { CSSProperties, ReactNode } from "react";

interface ScaledStageProps {
  readonly children: ReactNode;
  readonly className?: string;
}

export const ScaledStage = ({ children, className = "" }: ScaledStageProps) => {
  const hostRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const update = () => setScale(Math.max(0.1, Math.min(host.clientWidth / 800, host.clientHeight / 600)));
    const observer = new ResizeObserver(update);
    observer.observe(host);
    update();
    return () => observer.disconnect();
  }, []);

  const style = { "--stage-scale": scale } as CSSProperties;
  return (
    <div ref={hostRef} className="stage-host" style={style}>
      <div className={`stage ${className}`}>{children}</div>
    </div>
  );
};
